import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ChevronRight, Menu, X } from "lucide-react";
import { GOOGLE_FORM_URL } from "../constants";

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? "nav-active" : undefined;

  return (
    <nav className="nav-wrap" aria-label="Navigație principală">
      <Link to="/" className="brand">
        <span className="brand-name">Lutuu</span>
      </Link>

      <div className="nav-links">
        <NavLink to="/" end className={linkClass}>Acasă</NavLink>
        <NavLink to="/blog" className={linkClass}>Blog</NavLink>
        <NavLink to="/contact" className={linkClass}>Contact</NavLink>
        <NavLink to="/urmareste-ne" className={linkClass}>Urmărește-ne pe:</NavLink>
      </div>

      <a className="nav-cta" href={GOOGLE_FORM_URL} target="_blank" rel="noopener noreferrer">
        Trimite un clip <ChevronRight size={17} />
      </a>

      <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Deschide meniul">
        {menuOpen ? <X /> : <Menu />}
      </button>

      {menuOpen && (
        <div className="mobile-menu">
          <NavLink to="/" end className={linkClass}>Acasă</NavLink>
          <NavLink to="/blog" className={linkClass}>Blog</NavLink>
          <NavLink to="/contact" className={linkClass}>Contact</NavLink>
          <NavLink to="/urmareste-ne" className={linkClass}>Urmărește-ne pe:</NavLink>
          <a className="mobile-submit" href={GOOGLE_FORM_URL} target="_blank" rel="noopener noreferrer">Trimite un clip</a>
        </div>
      )}
    </nav>
  );
}
